import React from "react";
import { lightIcon } from "./icons";

const TierLevel = ({ className = "" }) => {
  return (
    <div className={`platinium-tier ${className}`}>
      <div className="flex items-center gap-2">
        <span>{lightIcon}</span>
        <span>Platinum Tier</span>
      </div>
    </div>
  );
};

export default TierLevel;
